import * as React from 'react';

const UserItem = (props) => {
  return (
    <div className="user-item pointer">
      <p className="user-item__title">{props.title}</p>
      <p className="user-item__content">{props.content}</p>
    </div>
  );
}

export default UserItem;



// WEBPACK FOOTER //
// ./src/theme/auth/UserItem.js